import type { ManagementReservationSearchTypeForQueryParams } from "@/routes/_constants/query-params/management";

import { useViewData } from "../view-data";
import { useFilteredQueryDataBySearchModel } from "./use-filtered-query-data-by-search-model";
import { useSearchModel } from "./use-search-model";
import { useSearchReservationList } from "./use-search-reservation-list-query-data";

type Props = {
	hotelID: string;
	reservationSearchType: ManagementReservationSearchTypeForQueryParams;
	startDate: string;
	endDate: string;
	reservationID: string;
};

export const useInitialized = ({ hotelID, reservationSearchType, startDate, endDate, reservationID }: Props) => {
	const {
		queryData,
		// 検索条件
		queryVariables,
		// 予約の検索
		onSearchReservationList,
	} = useSearchReservationList({ hotelID, reservationSearchType, startDate, endDate, reservationID });

	/**
	 * SearchModel の生成
	 */
	const {
		// 詳細検索条件
		searchModel,
		//
		// 詳細検索のフリーワードテキストの変更（空白区切り）
		onChangeFreeWordText,
		// 詳細検索のアクティブな予約フラグの変更
		onChangeIsActiveChecked,
		// 詳細検索のキャンセル済みフラグの変更
		onChangeIsCanceledChecked,
		// 詳細検索のメルマガ配信希望者フラグの変更
		onChangeIsAcceptMailMagazineChecked,
		// 詳細検索の現地決済者フラグの変更
		onChangeIsLocalPaymentChecked,
		// 詳細検索の直接入力した予約フラグの変更
		onChangeIsHostReservationChecked,
		// 詳細検索の日帰り予約フラグの変更
		onChangeIsDayTripChecked,
		// 詳細検索の予約内容/プランでの検索条件の追加
		onAddReservationPlans,
		// 詳細検索の予約内容/プランでの検索条件の削除
		onRemoveReservationPlans,
		// 詳細検索の予約内容/部屋での検索条件の追加
		onAddReservationRooms,
		// 詳細検索の予約内容/部屋での検索条件の削除
		onRemoveReservationRooms,
		// 詳細検索の予約内容/オプションでの検索条件の追加
		onAddReservationOptions,
		// 詳細検索の予約内容/オプションでの検索条件の削除
		onRemoveReservationOptions,
		// 詳細検索の予約内容/ディスカウントでの検索条件の追加
		onAddReservationDiscounts,
		// 詳細検索の予約内容/ディスカウントでの検索条件の削除
		onRemoveReservationDiscounts,
	} = useSearchModel({ queryData });

	/**
	 * SearchModel をもとに QueryData をフィルタリングする
	 */
	const { queryData: filteredQueryData } = useFilteredQueryDataBySearchModel({ queryData, searchModel });

	/**
	 * ViewData の生成
	 */
	const { viewData } = useViewData({ queryData, filteredQueryData });

	return {
		//
		// readonly
		viewData,
		//
		// readonly
		queryVariables,
		// searchable
		searchModel,
		// 詳細検索のフリーワードテキストの変更（空白区切り）
		onChangeFreeWordText,
		// 予約の検索
		onSearchReservationList,
		// 詳細検索のアクティブな予約フラグの変更
		onChangeIsActiveChecked,
		// 詳細検索のキャンセル済みフラグの変更
		onChangeIsCanceledChecked,
		// 詳細検索のメルマガ配信希望者フラグの変更
		onChangeIsAcceptMailMagazineChecked,
		// 詳細検索の現地決済者フラグの変更
		onChangeIsLocalPaymentChecked,
		// 詳細検索の直接入力した予約フラグの変更
		onChangeIsHostReservationChecked,
		// 詳細検索の日帰り予約フラグの変更
		onChangeIsDayTripChecked,
		// 詳細検索の予約内容/プランでの検索条件の追加
		onAddReservationPlans,
		// 詳細検索の予約内容/プランでの検索条件の削除
		onRemoveReservationPlans,
		// 詳細検索の予約内容/部屋での検索条件の追加
		onAddReservationRooms,
		// 詳細検索の予約内容/部屋での検索条件の削除
		onRemoveReservationRooms,
		// 詳細検索の予約内容/オプションでの検索条件の追加
		onAddReservationOptions,
		// 詳細検索の予約内容/オプションでの検索条件の削除
		onRemoveReservationOptions,
		// 詳細検索の予約内容/ディスカウントでの検索条件の追加
		onAddReservationDiscounts,
		// 詳細検索の予約内容/ディスカウントでの検索条件の削除
		onRemoveReservationDiscounts,
	};
};
